import { DOCUMENT, isPlatformBrowser, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ApplicationRef, DestroyRef, inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import localeDE from '@angular/common/locales/de';
import localeFR from '@angular/common/locales/fr';
import localeNL from '@angular/common/locales/nl';
import * as moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
registerLocaleData(localeDE, 'de-DE');
registerLocaleData(localeFR, 'fr-FR');
registerLocaleData(localeNL, 'nl-NL');
@Injectable(
    { providedIn: 'root' }
)
export class I18nService {
    data: {};
    private _currentLang: string;
    private _locales = {
        de: localeDE,
        fr: localeFR,
        nl: localeNL
    };

    private lang$: BehaviorSubject<string>;
    destroyRef = inject(DestroyRef);

    constructor(
        private http: HttpClient,
        private ref: ApplicationRef,
        @Inject(DOCUMENT) protected dom,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.lang$ = new BehaviorSubject('de');
    }

    public get lang(): string {
        return this._currentLang || 'de';
    }

    public get langLong(): string {
        return this._currentLang + '-' + this._currentLang?.toLocaleUpperCase() || 'de-DE';
    }

    public get langOb() {
        return this.lang$.asObservable();
    }

    public get langUp() {
        return this._currentLang?.toLocaleUpperCase() || 'DE';
    }

    setLanguage(lang): void {
        if (this._locales[lang] && this._currentLang !== lang) {
            // console.log(this._locales[lang]);
            registerLocaleData(this._locales[lang], lang + '-' + lang.toLocaleUpperCase());
            // console.log(lang + '-' + lang.toLocaleUpperCase())
            this._currentLang = lang;
        }
        this._currentLang = lang;
        moment.locale(this._currentLang);
        if (isPlatformBrowser(this.platformId)) {
            this.fetch(lang);
        }
    }

    public translate(key: string, lang?: string): string {
        lang = lang || this.lang;
        return this.data?.[key] || key;
    }

    private fetch(locale: any) {
        const langFilePath = `./assets/translation/lang-${locale}.json`;
        this.fetchLangFile(langFilePath).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((data: any) => {
            this.data = data;
            this.ref.tick();
            this.lang$.next(locale);
        })
    }

    private fetchLangFile(url): Observable<any> {
        // const baseurl = this.dom.location.protocol + '//' + this.dom.location.hostname + (this.dom.location.port ? ':' + this.dom.location.port : '') + '/';
        return this.http.get(url)
            .pipe(
                map((data: any) => (data?.data || data))
            );
    }
}
